import { vuexTypes } from '../types'
import { notificationsService } from '@api/notifications.service'

const state = {
  messages: [],
  sseInitiated: false
}

const mutations = {
  UPDATE_MESSAGES (state, messages) {
    state.messages = messages
  },
  /**
   *
   * @param state
   * @param event MessageEvent
   * @constructor
   */
  SSE_NEW_MESSAGES (state, event) {
    if (event.data === 'null') {
      return
    }

    const array = JSON.parse(event.data)
    for (const message of array) {
      state.messages.push(message)
    }
  }
}

const actions = {
  async GET_UNREAD_MESSAGES ({ state, commit }) {
    if (!state.sseInitiated) {
      notificationsService.sse((event) => commit(vuexTypes.SSE_NEW_MESSAGES, event))
    }
    const resp = await notificationsService.loadUnreadNotifications()
    if (resp._parsedData.messages) {
      const uniqueArray = resp._parsedData.messages.filter((value, index, self) =>
        index === self.findIndex((t) => t.id === value.id)
      )
      commit(vuexTypes.UPDATE_MESSAGES, uniqueArray)
    } else {
      commit(vuexTypes.UPDATE_MESSAGES, [])
    }
  },
  async MARK_READ_MESSAGES ({ state, commit }, filter) {
    await notificationsService.readMessages(filter)
    let buf = []
    for (const message of state.messages) {
      if (filter.indexOf(message.id) === -1) {
        buf.push(message)
      }
      commit(vuexTypes.UPDATE_MESSAGES, buf)
    }
  }
}

const getters = {
  getUnreadMessages: state => state.messages
}

export default {
  actions,
  getters,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/notifications.module.js